<template>
  <div class="flex flex-col h-full w-full text-yellow-500 bg-red-500">
    <div class="heading-container mx-auto">
      <h1 :class="offerHeadingStyle" class="text-5xl font-bold py-4 px-8">OFFER #1</h1>
    </div>

    <div class="flex flex-col container mx-auto h-full px-32">
      <vue-typed-js class="flex flex-col container h-full xl:px-32 2xl:px-0"
       :strings="['We offer you the chance to acquire our Platform by the name of BLISSING.<br><br> ^500 With BLISSING, we have accomplished an exceptionally innovative Introduction to the field of Digital Media called:<br>Inside Media.<br><br> ^500 Our Platform cultivates the intrinsic abilities within People; mentally as well as psychologically… intellectually and emotionally…<br><br> ^500 The Platform serves the User’s ‘I’, by helping it find happiness. <br> ^500 BLISSING is not currently launched on any market. However, all elements required for its launch have already been created.<br><br> ^500 BLISSING can easily be incorporated within established networking Platforms such as: <br>FACEBOOK, INSTAGRAM &#38; WHATSAPP.<br><br> ^500 We offer our Platform in its entirety to Mark Zuckerberg exclusively, because we share his vision… unquestionably &#38; comprehensively.<br><br> ^500 No other company gets this offer. <br>That is guaranteed.']"
       :typeSpeed="25"
       :showCursor="false"
       @onComplete="textCompleted()">

        <div :class="offerTextStyle" class="offer-1-text text-left flex flex-col w-full leading-tight">
          <h1 class="typing"></h1>
        </div>

      </vue-typed-js>

      <div :class="signatureContainerStyle" class="flex justify-end items-center">
          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/PRIVORITY_Logo.png" alt="privority logo" class="w-64 mr-4">
          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/KENO+ONEO+SIGNATURE.png" alt="keno oneo signature" class="w-24">
      </div>
    </div>

    <IntroSkipButton text-color="yellow"/>
  </div>
</template>

<script>
import IntroSkipButton from "@/components/introduction/IntroSkipButton.vue";

export default {
  name: "IntroSecondPage",
  components:{
    IntroSkipButton
  },
  methods:{
    progressForward(){
      Event.$emit('skipIntroForward');
    },
    textCompleted(){
      setTimeout(() =>{ this.progressForward() }, 2000);
    }
  },
  computed: {
    offerHeadingStyle: function () {
      return {
        'mt-0': window.innerHeight < 900,
        'mt-12': window.innerHeight > 900,
      }
    },
    offerTextStyle: function () {
      return {
        'text-lg mt-0': window.innerHeight < 800,
        'text-xl mt-10': window.innerHeight > 800 && window.innerWidth < 1921,
        'text-3xl mt-10': window.innerHeight > 800 && window.innerWidth > 1920,
      }
    },
    signatureContainerStyle: function () {
      return {
        '-mt-20': window.innerHeight < 900,
      }
    },
  },
  mounted(){
    Event.$emit('playAudio', 'Start');
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box-width{
  width: 23rem;
}
</style>
